export const SCHEDULE_VISIT = 'SCHEDULE_VISIT';
export const SCHEDULE_VISIT_SUCCESS = 'SCHEDULE_VISIT_SUCCESS';
export const SCHEDULE_VISIT_FAILS = 'SCHEDULE_VISIT_FAILS';
export const SCHEDULE_VISIT_RESET = 'SCHEDULE_VISIT_RESET';

// get the user details
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_FAILS = 'GET_USER_DETAILS_FAILS';
